const styles = theme => ({
  header: {
    color: 'var(--mcg-dark, #002E47)',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%;' /* 18px */,
  },
  alignment: {
    display: 'flex',
    padding: '4px',
    alignItems: 'flex-start',
    gap: '8px',
    alignSelf: 'stretch',
    borderRadius: '6px',
    background: 'var(--mcg-bg, #F4F6F8)',
  },
  button: {
    width: '66.67',
    borderRadius: '4px',
  },
  icon: {
    width: '20px',
    height: '20px',
  },
  row: {
    display: 'grid',
    gap: '4px',
  },
  box: {
    display: 'grid',
    gap: '12px',
  },
})

export default styles
